import * as types from './appTypes';

export function clearAppState() {
  return {
    type: types.CLEAR_STATE,
  };
}



// WEBPACK FOOTER //
// ./src/state/reducers/app/appActions.js